//创建icons/svg目录，存放svg图标
//加载所有svg图标
const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('@/components/icon/svg', false, /\.svg$/)
requireAll(req)
